import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  dataInRequest,
  deleteData,
  findData,
  // recordFiltering,
} from '~/store/modules/empresacliente/actions';

import MyForm from './form';

function EmpresaCliente() {
  const redux = useSelector((state) => state.empresacliente);

  // Options
  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'idempresaveiculo',
        label: t('s.cadastro.empresaveiculo.idempresaveiculo'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'nomeempresaveiculo',
        label: t('s.cadastro.empresaveiculo.nomeempresaveiculo'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'statusempresaveiculo',
        label: t('s.cadastro.empresaveiculo.statusempresaveiculo'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ],
    [status]
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={dataInRequest}
      find={findData}
      remove={deleteData}
      form={MyForm}
      keys="idempresaveiculo"
      detach="idempresaveiculo"
    />
  );
}

export default EmpresaCliente;
